import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { fetchTenantUsersService } from '../../../components/Support/services/masterData';

import type { UserIdName } from './support.types';
import { createInitialMasterState } from './helpers';

export const fetchTenantUsersAsyncThunk = createAsyncThunk<UserIdName[], void>(
  'supportTenantUsers/fetchTenantUsers',
  async (_, { rejectWithValue }) => {
    const response = await fetchTenantUsersService();
    if (!response.status || !response.records) {
      return rejectWithValue('Internal Server Error');
    }
    return response.records;
  }
);

export const tenantUsersSlice = createSlice({
  name: 'supportTenantUsers',
  initialState: createInitialMasterState<UserIdName>(),
  reducers: {
    clearError: state => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchTenantUsersAsyncThunk.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchTenantUsersAsyncThunk.fulfilled,
        (state, action: PayloadAction<UserIdName[]>) => {
          state.loading = false;
          state.data = action.payload;
        }
      )
      .addCase(fetchTenantUsersAsyncThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = tenantUsersSlice.actions;
export default tenantUsersSlice.reducer;
